import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { sortByKey, isNumeric } from '~/core/scripts/utils';
import InnerRanking from '../InnerRanking';

class GreenestRanking extends PureComponent {
  state = {
    expandedIndex: 0
  }

  constructor(props) {
    super();

    const { valueKey, data } = props;

    this.data = data
      .filter(d => isNumeric(d[valueKey]) && !['888', '999'].includes(d.AGS))
      .sort(sortByKey('rank', false));
  }

  onItemClick(index) {
    this.setState(prevState => ({
      expandedIndex: prevState.expandedIndex === index ? null : index
    }));
  }

  renderExpanded(item) {
    const items = this.props.dataInfo.map(col => ({
      ...col,
      value: item[col.key]
    }));

    return (
      <InnerRanking
        items={items}
        greenVoters={item.Gruene}
      />
    );
  }

  renderItem(item, index) {
    const { valueKey, germanyData, dataInfo } = this.props;
    const isExpanded = index === this.state.expandedIndex;
    const itemClasses = classnames('ranking__itemwrapper', { active: isExpanded });

    const greenestIndex = dataInfo.reduce((res, col) => {
      const isAbove = col.key !== 'muell_pk' && item[col.key] > germanyData[col.key];
      const isBelow = col.key === 'muell_pk' && item[col.key] < germanyData[col.key];

      if (isAbove || isBelow) {
        res++;
      }

      return res;
    }, 0);

    return (
      <div className={itemClasses} key={`greenestranking__${valueKey}_${index}`}>
        <div className="ranking__item" onClick={() => this.onItemClick(index)}>
          <div className="ranking__index">{index + 1}</div>
          <div className="ranking__name">
            <div className="ranking__name-kreis">{item.Kreis}</div>
            <div className="ranking__name-index">
              <strong className="index-value">{item.group}</strong><span className="index-max">/5</span>
            </div>
          </div>
        </div>
        {isExpanded && this.renderExpanded(item)}
      </div>
    );
  }

  render() {
    return (
      <div className="greenest__topranking">
        <div className="ranking__title">Die Top-Kreise</div>
        <div className="ranking__list">
          {this.data.slice(0, 5).map((d, i) => this.renderItem(d, i))}
        </div>
      </div>
    );
  }
}

export default GreenestRanking;
